import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { first, switchMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Session } from '../../shared/models/identity.model';
import { SessionService } from '../services/session.service';

@Injectable({
	providedIn: 'root',
})
export class AuthInterceptor implements HttpInterceptor {
	private sessionService: SessionService = inject(SessionService);

	intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
		request = request.clone({ url: request.url.replace('http://', 'https://') });

		if (!this.requiresAuth(request)) {
			return next.handle(request);
		}

		return this.sessionService.session$.pipe(
			first(),
			switchMap((session: Session) => next.handle(request.clone({ headers: request.headers.set('Authorization', `Bearer ${session.id}`) })))
		);
	}

	private requiresAuth(request: HttpRequest<unknown>): boolean {
		return request.url.includes(environment.trovataApi);
	}
}
